const notificationReducer = (state, action) => {
    switch(action.type){
       
        case 'SET_LOADING':
            return {
                ...state,
                loading: true
            }

        case 'STOP_LOADING':
            return {
                ...state,
                loading: false
            }


        case 'GET_NOTIFICATIONS':
            return {
                ...state,
                notifications: action.payload,
                loading: false,
            }

        case 'GET_TOP_TEN_NOTIFICATIONS':
            return {
                ...state,
                notifications: action.payload,
                loading: false,
            }

        case 'GET_NOTIFICATION':
            return {
                ...state,
                notification: action.payload,
                loading: false,
            }

        case 'ADD_NOTIFICATION':
            return {
                ...state,
                notifications: [action.payload, ...state.notifications],
            }

        case 'REMOVE_NOTIFICATION':
            return {
                ...state,
                notifications: state.notifications.filter(notification => notification.id !== action.payload.id),
            }

        default:
            return state
    }
}

export default notificationReducer;